$(document).ready(function() {
	MenuTab.init();
	MenuTab.resize();
});

$(window).resize(function(event) {
	MenuTab.resize();
});

MenuTab = {
	elm:{},
	items:{},
	isBlocked: true,
	init: function () {

		this.elm = $('.menu.nav-tabs');
		this.items = $('.menu.nav-tabs li');
	},

	bind: function () {
		this.items.click(function(event) {
			event.preventDefault();
			MenuTab.show();
		});
	},

	show: function(){
		// this.elm.addClass('opened');
		this.items.slideDown(300);
		this.items.unbind('click');
	},

	resize: function(){
		this.isBlocked = false;
		if (window.innerWidth >= 1024){
			this.isBlocked = true;
			this.items.unbind('click');
			this.items.css({display: 'inline-block'});
			return;
		}
		this.items.css({display: ''});
		this.bind();
	}
}